export default __webpack_public_path__ + "static/media/Full Device.e16965a2.png";